import React from 'react';
import { useFormContext } from 'react-hook-form';

interface TransientFieldProps {
  children: React.ReactElement;
}

function TransientField({ children }: TransientFieldProps) {
  const { resetField } = useFormContext();
  React.useEffect(() => () => resetField(children.props.name), [children.props.name, resetField]);
  return children;
}

export default TransientField;
